var _rect, _rect2, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCnilCertification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 160",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "CNIL") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 160,
    rx: 18,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 44,
    width: 144,
    height: 72,
    rx: 16,
    fill: "#07559d"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 91,
    fill: "#fff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 34,
    fontWeight: 700,
    textAnchor: "middle"
  }, "CNIL")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnilCertification);
export default __webpack_public_path__ + "static/media/cnil-certification.8ba948cb927e302fa934bca95214c209.svg";
export { ForwardRef as ReactComponent };